import { render, staticRenderFns } from "./HealthComponent.vue?vue&type=template&id=16d118bc&scoped=true&"
import script from "./HealthComponent.vue?vue&type=script&lang=js&"
export * from "./HealthComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d118bc",
  null
  
)

export default component.exports